import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import urls from '../../../../../utils/urls';
import { getIntl } from '../../../../../utils/intl';
import useMedicalProfileCardsCards from '../../../../../hooks/api/useMedicalProfileCards';
import CardForm from '../../../../shared/CardForm';
import useSetHeaderTitle from '../../../../../hooks/useSetHeaderTitle';
import ViewCard from './ViewCard';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

export type EditCardScreenOwnProps = {};

export type EditCardScreenProps = EditCardScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'edit-card'>;
};

const intl = getIntl('CardDetails', {
    headerTemplate: 'View {cardType}',
    description: '{cardType} Description',
    image: '{cardType} Image',
    id: 'ID Card',
    insurance: 'Insurance Card',
    delete: 'Delete {cardType}',
    edit: 'Edit {cardType}',
    cancelEdit: 'Cancel Edit',
});

const EditCardScreen: React.FC<EditCardScreenProps> = ({
    route: {
        params: { profileId, cardType, cardId, description },
    },
}) => {
    const goBack = useGoBack();
    const {
        isDeletingIdCard,
        isUpdatingIdCard,
        updateIdCard,
        isDeletingInsuranceCard,
        updateInsuranceCard,
        isUpdatingInsuranceCard,
    } = useMedicalProfileCardsCards({
        medicalProfileId: profileId,
        onUpdateCardSuccess: () => {
            goBack();
        },
    });
    const [isViewMode, setIsViewMode] = React.useState(true);
    const editTitle = intl('edit', { cardType: intl(cardType) });
    const viewTitle = intl('headerTemplate', { cardType: intl(cardType) });
    useSetHeaderTitle(isViewMode ? viewTitle : editTitle);
    const imageUrl =
        cardType === 'id'
            ? urls.api.medicalProfiles.cards.idCardImage(profileId, cardId)
            : urls.api.medicalProfiles.cards.insuranceCardImage(profileId, cardId);

    const updateHappening = isUpdatingIdCard || isUpdatingInsuranceCard || isDeletingIdCard || isDeletingInsuranceCard;

    const renderViewMode = () => (
        <ViewCard
            onEdit={() => setIsViewMode(false)}
            profileId={profileId}
            cardType={cardType}
            cardId={cardId}
            description={description}
        />
    );

    const renderEdit = () => (
        <CardForm
            initialDescription={description}
            initialImageUrl={imageUrl}
            isDisabled={updateHappening}
            cardType={cardType}
            isLoading={updateHappening}
            onCancel={() => setIsViewMode(true)}
            onSubmit={(value) => {
                const body = {
                    cardId: cardId,
                    update: {
                        description: value.description,
                        image: value.imageChange,
                    },
                };
                if (cardType === 'id') {
                    updateIdCard(body);
                } else {
                    updateInsuranceCard(body);
                }
            }}
        />
    );

    return (
        <ProfileHeaderContainer profileId={profileId} bottomBorder omitChatButton>
            {isViewMode ? renderViewMode() : renderEdit()}
        </ProfileHeaderContainer>
    );
};

export default React.memo(EditCardScreen);
